import { useEffect, useState } from "react";
import { useLenis } from "lenis/react";

export default function ScrollProgress() {
  const [scale, setScale] = useState(0);
  const lenis = useLenis();

  useEffect(() => {
    const onScroll = () => {
      const el = document.documentElement;
      const max = el.scrollHeight - el.clientHeight;
      setScale(max > 0 ? el.scrollTop / max : 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [lenis]);

  return (
    <div
      className="progress"
      style={{ transform: `scaleX(${scale})` }}
      aria-hidden="true"
    />
  );
}
